import type { Config } from '@puckeditor/core';

const RAW_PARAGRAPH_HTML_FIELD = { type: 'textarea' as const, label: 'Text' };

type Components = NonNullable<Config['components']>;

/**
 * Puck 0.23's production `<Render>` scans component fields and replaces every `richtext` prop with
 * a `RichTextRender` ReactNode before calling the component. Text (internal key `Paragraph`) must
 * receive raw saved HTML so its render can interpolate tenant variables and sanitize the result.
 *
 * The editor keeps the real `richtext` field. Only production configs pass through this adapter,
 * changing the field discriminator Puck scans while preserving the same render/defaults and every
 * other component definition.
 */
export function createProductionComponents(components: Components): Components {
  const paragraph = components.Paragraph;
  return {
    ...components,
    Paragraph: {
      ...paragraph,
      fields: {
        ...paragraph.fields,
        text: RAW_PARAGRAPH_HTML_FIELD,
      },
    },
  };
}
